module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: 'uk-child-width-1-' + _vm.size + '@m',
    attrs: {
      "uk-grid": ""
    }
  }, _vm._l((_vm.images), function(i) {
    return _c('div', [_c('img', {
      attrs: {
        "src": i.url,
        "alt": i.alt,
        "title": i.title
      }
    })])
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-366361d3","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/CORE/modules/MEDIA/VueImage.vue
// module id = 510
// module chunks = 1